'use client';

import { twJoin } from '@tuic/tailwind-config';

import { Button } from '../../../../core-components/Button';
import {
  Pictogram,
  type PictogramName,
} from '../../../../core-components/Pictogram';

import type React from 'react';

export type DashboardTravelItineraryPlanCardProps = {
  className?: string;
  pictogram?: PictogramName;
  headline?: string;
  subline?: string;
  cta?: React.ReactNode;
};

export const DashboardTravelItineraryPlanCard = ({
  className,
  pictogram,
  headline,
  subline,
  cta,
}: DashboardTravelItineraryPlanCardProps) => {
  return (
    <div
      className={twJoin(
        'flex flex-col gap-8 md:gap-6 text-marine-high-emphasis',
        'text-center md:text-start',
        className,
      )}
    >
      <div className="flex flex-col gap-4">
        {pictogram && (
          <Pictogram
            name={pictogram}
            size="md"
            className="mx-auto block md:hidden"
          />
        )}
        {headline && <h2 className="headline-lg md:headline-md">{headline}</h2>}
        {subline && <p className="text-lg">{subline}</p>}
      </div>
      <div>
        {cta && (
          <Button asChild className="w-full sm:w-auto md:w-full">
            {cta}
          </Button>
        )}
      </div>
    </div>
  );
};
